export function fromArray<TArrayItem, TKey>(array: ReadonlyArray<TArrayItem>, keySelector: (arrayItem: TArrayItem, index: number) => TKey): Map<TKey, TArrayItem>;
export function fromArray<TArrayItem, TKey, TValue>(array: ReadonlyArray<TArrayItem>, keySelector: (arrayItem: TArrayItem, index: number) => TKey, valueSelector: (arrayItem: TArrayItem, index: number) => TValue): Map<TKey, TValue>;
export function fromArray<TArrayItem, TKey>(mapfactory: () => Map<TKey, TArrayItem>, array: ReadonlyArray<TArrayItem>, keySelector: (arrayItem: TArrayItem, index: number) => TKey): Map<TKey, TArrayItem>;
export function fromArray<TArrayItem, TKey, TValue>(mapfactory: () => Map<TKey, TValue>, array: ReadonlyArray<TArrayItem>, keySelector: (arrayItem: TArrayItem, index: number) => TKey, valueSelector: (arrayItem: TArrayItem, index: number) => TValue): Map<TKey, TValue>;
export function fromArray<TArrayItem, TKey, TValue = TArrayItem>(
	mapFactoryOrArray: (() => Map<TKey, TValue>) | ReadonlyArray<TArrayItem>,
	arrayOrKeySelector: (ReadonlyArray<TArrayItem>) | ((arrayItem: TArrayItem, index: number) => TKey),
	keySelectorOrValueSelector?: ((arrayItem: TArrayItem, index: number) => TKey) | ((arrayItem: TArrayItem) => TValue),
	valueSelector?: (arrayItem: TArrayItem, index: number) => TValue
): Map<TKey, TValue> {
	let mapfactory: () => Map<TKey, TValue>;
	let array: ReadonlyArray<TArrayItem>;
	let keySelector: (arrayItem: TArrayItem, index: number) => TKey;

	if (Array.isArray(mapFactoryOrArray)) {
		mapfactory = () => new Map();
		array = mapFactoryOrArray;
		keySelector = arrayOrKeySelector as ((arrayItem: TArrayItem) => TKey);
		valueSelector = keySelectorOrValueSelector as ((arrayItem: TArrayItem) => TValue);
	} else {
		mapfactory = mapFactoryOrArray as (() => Map<TKey, TValue>);
		array = arrayOrKeySelector as ReadonlyArray<TArrayItem>;
		keySelector = keySelectorOrValueSelector as ((arrayItem: TArrayItem) => TKey);
	}

	if (!valueSelector) {
		valueSelector = a => a as any;
	}

	const result: Map<TKey, TValue> = mapfactory();

	for (let i = 0; i < array.length; i++) {
		const arrayItem: TArrayItem = array[i];
		result.set(keySelector(arrayItem, i), valueSelector(arrayItem, i));
	}

	return result;
}

export function serialize<TKey extends string | number, TValue>(map: Map<TKey, TValue>): string {
	return JSON.stringify([...map.entries()]);
}

export function deserialize<TKey extends string | number, TValue>(s: string): Map<TKey, TValue> {
	//this only deserializes strings that have structure similar to the output of Map.entries()
	// e.g [[1, "local"], [2,"online"]]
	const deserializedMap: Map<TKey, TValue> = new Map();
	const deserializedArrays: [TKey, TValue][] = JSON.parse(s);
	for (const i of deserializedArrays) {
		if (i.length > 2) {
			throw new Error(`Length for ${i} is too big deserialize does not support this structure`);
		}
		deserializedMap.set(i[0], i[1]);
	}
	return deserializedMap;
}